import React from 'react';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import PaymentIframe from '../../i-fram-asd';
import { PelecardResponse } from '../../i-fram-asd';
import { PaymentResponse } from '../../../../../api/types/payments/gateway/payment-gateway-response';

interface PaymentIframeDialogProps {
  paymentUrl: (PaymentResponse & { allocationId: number }) | null;
  loadingNotifySuccess: boolean;
  onHide: () => void;
  onPaymentSuccess: (data: PelecardResponse) => void;
}

export const PaymentIframeDialog: React.FC<PaymentIframeDialogProps> = ({
  paymentUrl,
  loadingNotifySuccess,
  onHide,
  onPaymentSuccess,
}) => {
  if (!paymentUrl) {
    return null;
  }

  return (
    <Dialog
      header="תשלום"
      visible={paymentUrl !== null}
      onHide={onHide}
      style={{
        width: '700px',
        height: '90vh',
        backgroundColor: 'white',
        borderRadius: '8px',
      }}
    >
      {loadingNotifySuccess ? (
        <ProgressSpinner
          style={{
            width: '400px',
            height: '400px',
            display: 'flex',
            justifyContent: 'center',
          }}
          strokeWidth="3"
          fill="var(--surface-ground)"
          animationDuration=".5s"
        />
      ) : (
        <PaymentIframe
          src={paymentUrl.url}
          successLink={paymentUrl.successUrl}
          failLink={paymentUrl.failUrl}
          onPaymentSuccess={(data: PelecardResponse) => {
            onPaymentSuccess(data);
          }}
          onPaymentError={(data?: PelecardResponse) => {
            //
          }}
        />
      )}
    </Dialog>
  );
};
